<template>
  <div class="selectTravelAgent">
    <b-form-group
      label="Select Travel Agent"
      label-for="travelAgents"
    >
      <b-row>
        <b-col cols="10">
          <treeselect v-model="localValue" :multiple="false" :options="options" placeholder="Select Travel Agent"/>
        </b-col>
        <b-col cols="2" class="pl-0 text-right">
          <b-button variant="outline-secondary" @click="toggle"><i class="icon-plus icons"></i></b-button>
        </b-col>
      </b-row>
    </b-form-group>
    <b-modal centered v-model="active" @ok="handleOk" :ok-disabled="!isEnabled" id="autoTravelAgent">
      <v-text-field
        @keyup.native="submitOnEnter"
        v-model="travelAgent"
        type="text"
        name="travelAgent"
        placeholder="Enter Travel Agent">
        <span slot="label">Travel Agent</span>
      </v-text-field>
    </b-modal>
  </div>
</template>

<script>
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: { Treeselect },

  props: {
    value: {
      required: true
    },
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    options: {
      type: [Object, Array],
      required: true
    }
  },
  data() {
    return {
      localValue: null,
      active: false,
      travelAgent: '',
      isBusy: false
    }
  },
  methods: {
    submitOnEnter(e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.submit()
      }
    },
    toggle() {
      this.active = !this.active
    },
    handleOk(e) {
      e.preventDefault()
      if (!this.isBusy) {
        this.submit()
      }
    },
    submit() {
      this.isBusy = true
      let xhr = this.$store.dispatch('travelAgents/store', {
        name: this.travelAgent
      })
      xhr.then(
        this.handleSubmitSuccess,
        this.handleSubmitFail
      )
    },
    handleSubmitSuccess(res) {
      this.$emit('input', res.data.data.id)
      this.active = false
      this.travelAgent = ''
      this.isBusy = false
    },
    handleSubmitFail() {
      this.isBusy = false
    }
  },
  computed: {
    isEnabled() {
      return (!this.isBusy && this.travelAgent && this.travelAgent !== '')
    }
  },
  watch: {
    localValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', newVal)
      }
    },
    value(newVal) {
      this.localValue = newVal
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Common/inputTravelAgent.vue